/**
 * ============================================================
 * Français
 * ============================================================
 *
 * Translators:
 *
 * BakaKiller, LoganTann (ShinProg)
 */

export default {
	'AdvanceHelp': 'Pour avancer dans le jeu, appuyez sur la touche espace ou cliquez',
	'AllowPlayback': 'Cliquez ici pour autoriser la musique de fond',
	'Audio': 'Audio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Activer la lecture automatique',
	'AutoPlaySpeed': 'Vitesse de lecture automatique',

	'Back': 'Retour',
	'BackButton': 'Retour',

	'Cancel': 'Annuler',
	'Close': 'Fermer',
	'Confirm': 'Voulez-vous vraiment quitter?',
	'Credits': 'Crédits',

	'Delete': 'Supprimer',
	'DialogLogButton': 'Afficher le journal de dialogues',

	'FullScreen': 'Plein Écran',

	'Gallery': 'Gallerie',

	'Help': 'Aide',
	'Hide': 'Cacher',
	'HideButton': 'Cacher le Texte',

	'iOSAudioWarning': 'Les paramètres audio ne sont pas pris en charge par iOS',

	'KeyboardShortcuts': 'Raccourcis claviers',

	'Language': 'Langue',
	'Load': 'Charger',
	'LoadAutoSaveSlots': 'Parties enregistrées automatiquement',
	'LoadButton': 'Ouvrir l’écran de chargement',
	'Loading': 'Chargement',
	'LoadingMessage': 'Veuillez patienter pendant le chargement des données du jeu',
	'LoadSlots': 'Parties Sauvegardées',
	'LocalStorageWarning': 'Le stockage local n’est pas disponible sur ce navigateur !',
	'Log': 'Journal',

	'Music': 'Volume de la Musique',

	'NewContent': 'Un nouveau contenu est disponible, rechargez la page pour obtenir la dernière version',
	'NoSavedGames': 'Pas de parties sauvegardées',
	'NoAutoSavedGames': 'Aucune partie enregistrée automatiquement',
	'NoDialogsAvailable': 'Aucun dialogue disponible. Les boîtes de dialogue apparaîtront ici au fur et à mesure qu\'elles s\'afficheront.',

	'OK': 'OK',
	'OrientationWarning': 'Changez l\'orientation de votre appareil pour jouer.',
	'Overwrite': 'Écraser',

	'QuickButtons': 'Boutons du Menu rapide',
	'QuickMenu': 'Menu rapide',
	'Quit': 'Quitter',
	'QuitButton': 'Quitter le Jeu',

	'Resolution': 'Résolution',

	'Save': 'Sauvegarder',
	'SaveButton': 'Ouvrir l’écran de Sauvegarde',
	'SaveInSlot': 'Enregistrer à l’emplacement',
	'SelectYourLanguage': 'Select your language',
	'Settings': 'Préférences',
	'SettingsButton': 'Ouvrir l’écran des Préférences',
	'Show': 'Monter',
	'Skip': 'Passer',
	'SkipButton': 'Skip mode',
	'SlotDeletion': 'Êtes-vous sûr de vouloir supprimer cet emplacement ?',
	'SlotOverwrite': 'Êtes vous sûr de vouloir remplacer cet emplacement ?',
	'Sound': 'Volume des Sons',
	'Start': 'Démarrer',
	'Stop': 'Arrêter',

	'TextSpeed': 'Vitesse du Texte',

	'Video': 'Volume des vidéos',
	'Voice': 'Volume de la Voix',

	'Windowed': 'Fenêtré'
};
